export const applyByIdCache = ({
  byId,
  search
}) => {
  const cache = {};
  const api = {
    byId: id => {
      if (Object.prototype.hasOwnProperty.call(cache, id)) {
        return Promise.resolve(cache[id]);
      }
      return byId(id).then(reference => {
        cache[id] = reference;
        return reference;
      });
    },
    refreshCache: id => {
      delete cache[id];
      return api.byId(id);
    },
    search
  };
  return api;
};